const BgVector2 = ({ color, className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="390"
      height="273"
      viewBox="0 0 390 273"
      fill="none"
      className={className}
    >
      <g filter="url(#filter0_f_1061_24228)">
        <path
          d="M203.792 269.512C98.0706 277.647 -69.2017 498.479 35.6523 482.703C59.088 479.177 71.2673 472.601 93.5761 464.602C134.219 450.03 157.498 397.368 194.54 419.55C233.354 442.794 171.509 496.458 194.54 535.398C239.349 611.156 376.263 532.527 402.503 448.512C433.64 348.818 307.928 261.498 203.792 269.512Z"
          fill={color || "#EBBD07"}
        />
      </g>
      <defs>
        <filter
          id="filter0_f_1061_24228"
          x="-266.3"
          y="0.298035"
          width="942.332"
          height="834.404"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="134.351"
            result="effect1_foregroundBlur_1061_24228"
          />
        </filter>
      </defs>
    </svg>
  );
};
export default BgVector2;
